var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comment-form comment-form-wrap" },
    [
      _vm.first
        ? _c("h3", [_vm._v("Be the first!")])
        : _c("h3", [_vm._v("Leave a comment")]),
      _vm.submitted
        ? _c(
            "alert",
            { staticClass: "alert-success", attrs: { role: "alert" } },
            [_vm._v("Thank you. Your comment has been submitted!")]
          )
        : _vm._e(),
      !_vm.submitted
        ? _c("div", [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "commenter" } }, [_vm._v("Name")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.commenter,
                    expression: "commenter",
                  },
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.commenter == "" && _vm.commenterBlured,
                },
                domProps: { value: _vm.commenter },
                on: {
                  blur: function ($event) {
                    _vm.commenterBlured = true
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.commenter = $event.target.value
                  },
                },
              }),
              _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v("This is required"),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "email" } }, [
                _vm._v("Email address"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": !_vm.validEmail(_vm.email) && _vm.emailBlured,
                },
                domProps: { value: _vm.email },
                on: {
                  blur: function ($event) {
                    _vm.emailBlured = true
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  },
                },
              }),
              _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v("A valid email is required"),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _vm._m(0),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.website,
                    expression: "website",
                  },
                ],
                staticClass: "form-control",
                domProps: { value: _vm.website },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.website = $event.target.value
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "content" } }, [_vm._v("Comment")]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.content,
                    expression: "content",
                  },
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.content == "" && _vm.contentBlured },
                domProps: { value: _vm.content },
                on: {
                  blur: function ($event) {
                    _vm.contentBlured = true
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.content = $event.target.value
                  },
                },
              }),
              _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v("This is required"),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-lg btn-success",
                  attrs: { type: "submit", href: "#" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Submit")]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "website" } }, [
      _vm._v("Website"),
      _c("i", [_vm._v("(optional)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }